// Get all buildings
export const GET_ALL_BUILDINGS_REQUEST = "GET_ALL_BUILDINGS_REQUEST";
export const GET_ALL_BUILDINGS_SUCCESS = "GET_ALL_BUILDINGS_SUCCESS";
export const GET_ALL_BUILDINGS_FAILURE = "GET_ALL_BUILDINGS_FAILURE";

// Add building
export const ADD_BUILDING_REQUEST = "ADD_BUILDING_REQUEST";
export const ADD_BUILDING_SUCCESS = "ADD_BUILDING_SUCCESS";
export const ADD_BUILDING_FAILURE = "ADD_BUILDING_FAILURE";

// Update building
export const UPDATE_BUILDING_REQUEST = "UPDATE_BUILDING_REQUEST";
export const UPDATE_BUILDING_SUCCESS = "UPDATE_BUILDING_SUCCESS";
export const UPDATE_BUILDING_FAILURE = "UPDATE_BUILDING_FAILURE";

export const UPDATE_MULTI_BUILDING_REQUEST = "UPDATE_MULTI_BUILDING_REQUEST";
export const UPDATE_MULTI_BUILDING_SUCCESS = "UPDATE_MULTI_BUILDING_SUCCESS";
export const UPDATE_MULTI_BUILDING_FAILURE = "UPDATE_MULTI_BUILDING_FAILURE";

export const GET_BUILDING_COMMON_DATA_BY_IDS_REQUEST = "GET_BUILDING_COMMON_DATA_BY_IDS_REQUEST";
export const GET_BUILDING_COMMON_DATA_BY_IDS_SUCCESS = "GET_BUILDING_COMMON_DATA_BY_IDS_SUCCESS";
export const GET_BUILDING_COMMON_DATA_BY_IDS_FAILURE = "GET_BUILDING_COMMON_DATA_BY_IDS_FAILURE";
export const RESET_BUILDING_COMMON_DATA = "RESET_BUILDING_COMMON_DATA";
// Delete building
export const DELETE_BUILDING_REQUEST = "DELETE_BUILDING_REQUEST";
export const DELETE_BUILDING_SUCCESS = "DELETE_BUILDING_SUCCESS";
export const DELETE_BUILDING_FAILURE = "DELETE_BUILDING_FAILURE";

// Get buildings summary data
export const GET_BUILDINGS_SUMMARY_REQUEST = "GET_BUILDINGS_SUMMARY_REQUEST";
export const GET_BUILDINGS_SUMMARY_SUCCESS = "GET_BUILDINGS_SUMMARY_SUCCESS";
export const GET_BUILDINGS_SUMMARY_FAILURE = "GET_BUILDINGS_SUMMARY_FAILURE";

// assign building
export const ASSIGN_BUILDING_FOR_USER_REQUEST = "ASSIGN_BUILDING_FOR_USER_REQUEST";
export const ASSIGN_BUILDING_FOR_USER_SUCCESS = "ASSIGN_BUILDING_FOR_USER_SUCCESS";
export const ASSIGN_BUILDING_FOR_USER_FAILURE = "ASSIGN_BUILDING_FOR_USER_FAILURE";

//  UN assign building
export const UNASSIGN_BUILDING_FOR_USER_REQUEST = "UNASSIGN_BUILDING_FOR_USER_REQUEST";
export const UNASSIGN_BUILDING_FOR_USER_SUCCESS = "UNASSIGN_BUILDING_FOR_USER_SUCCESS";
export const UNASSIGN_BUILDING_FOR_USER_FAILURE = "UNASSIGN_BUILDING_FOR_USER_FAILURE";

// Ger region based on client
export const GET_REGIONS_BASED_ON_CLIENT_REQUEST = "GET_REGIONS_BASED_ON_CLIENT_REQUEST";
export const GET_REGIONS_BASED_ON_CLIENT_SUCCESS = "GET_REGIONS_BASED_ON_CLIENT_SUCCESS";
export const GET_REGIONS_BASED_ON_CLIENT_FAILURE = "GET_REGIONS_BASED_ON_CLIENT_FAILURE";

export const GET_DEPARTMENT_BASED_ON_PROJECT_REQUEST = "GET_DEPARTMENT_BASED_ON_PROJECT_REQUEST";
export const GET_DEPARTMENT_BASED_ON_PROJECT_SUCCESS = "GET_DEPARTMENT_BASED_ON_PROJECT_SUCCESS";
export const GET_DEPARTMENT_BASED_ON_PROJECT_FAILURE = "GET_DEPARTMENT_BASED_ON_PROJECT_FAILURE";

// Ger get_sites_based_on_region
export const GET_SITES_BASED_ON_REGION_REQUEST = "GET_SITES_BASED_ON_REGION_REQUEST";
export const GET_SITES_BASED_ON_REGION_SUCCESS = "GET_SITES_BASED_ON_REGION_SUCCESS";
export const GET_SITES_BASED_ON_REGION_FAILURE = "GET_SITES_BASED_ON_REGION_FAILURE";

// Get all consultancy users
export const GET_ALL_CONSULTANCY_USERS_REQUEST = "GET_ALL_CONSULTANCY_USERS_REQUEST";
export const GET_ALL_CONSULTANCY_USERS_SUCCESS = "GET_ALL_CONSULTANCY_USERS_SUCCESS";
export const GET_ALL_CONSULTANCY_USERS_FAILURE = "GET_ALL_CONSULTANCY_USERS_FAILURE";

// Get all Clients
export const GET_ALL_CLIENTS_REQUEST = "GET_ALL_CLIENTS_REQUEST";
export const GET_ALL_CLIENTS_SUCCESS = "GET_ALL_CLIENTS_SUCCESS";
export const GET_ALL_CLIENTS_FAILURE = "GET_ALL_CLIENTS_FAILURE";

// Get Building by Id
export const GET_BUILDING_BY_ID_REQUEST = "GET_BUILDING_BY_ID_REQUEST";
export const GET_BUILDING_BY_ID_SUCCESS = "GET_BUILDING_BY_ID_SUCCESS";
export const GET_BUILDING_BY_ID_FAILURE = "GET_BUILDING_BY_ID_FAILURE";

// GET ALL COUNTRIES
export const GET_ALL_COUNTRIES_REQUEST = "GET_ALL_COUNTRIES_REQUEST";
export const GET_ALL_COUNTRIES_SUCCESS = "GET_ALL_COUNTRIES_SUCCESS";
export const GET_ALL_COUNTRIES_FAILURE = "GET_ALL_COUNTRIES_FAILURE";

// GET ALL BUILDINGS BASED ON SITE
export const GET_BUILDINGS_BASED_ON_SITE_REQUEST = "GET_BUILDINGS_BASED_ON_SITE_REQUEST";
export const GET_BUILDINGS_BASED_ON_SITE_SUCCESS = "GET_BUILDINGS_BASED_ON_SITE_SUCCESS";
export const GET_BUILDINGS_BASED_ON_SITE_FAILURE = "GET_BUILDINGS_BASED_ON_SITE_FAILURE";

// Upload Image
export const UPLOAD_IMAGE_REQUEST = "UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "UPLOAD_IMAGE_FAILURE";

// Get all Images
export const GET_ALL_IMAGES_REQUEST = "GET_ALL_IMAGES_REQUEST";
export const GET_ALL_IMAGES_SUCCESS = "GET_ALL_IMAGES_SUCCESS";
export const GET_ALL_IMAGES_FAILURE = "GET_ALL_IMAGES_FAILURE";

// Delete Images
export const DELETE_IMAGES_REQUEST = "DELETE_IMAGES_REQUEST";
export const DELETE_IMAGES_SUCCESS = "DELETE_IMAGES_SUCCESS";
export const DELETE_IMAGES_FAILURE = "DELETE_IMAGES_FAILURE";

// Update Comments Images
export const UPDATE_IMAGE_COMMENT_REQUEST = "UPDATE_IMAGE_COMMENT_REQUEST";
export const UPDATE_IMAGE_COMMENT_SUCCESS = "UPDATE_IMAGE_COMMENT_SUCCESS";
export const UPDATE_IMAGE_COMMENT_FAILURE = "UPDATE_IMAGE_COMMENT_FAILURE";

// Update Building Entity Params
export const UPDATE_BUILDING_ENTITY_PARAMS_SUCCESS = "UPDATE_BUILDING_ENTITY_PARAMS_SUCCESS";
export const UPDATE_BUILDING_ENTITY_PARAMS_FAILURE = "UPDATE_BUILDING_ENTITY_PARAMS_FAILURE";

export const GET_PROJECTS_BASED_ON_CLIENT_REQUEST = "GET_PROJECTS_BASED_ON_CLIENT_REQUEST";
export const GET_PROJECTS_BASED_ON_CLIENT_SUCCESS = "GET_PROJECTS_BASED_ON_CLIENT_SUCCESS";
export const GET_PROJECTS_BASED_ON_CLIENT_FAILURE = "GET_PROJECTS_BASED_ON_CLIENT_FAILURE";

// Get EFCI based on Building under Project
export const GET_EFCI_BASED_ON_BUILDING_REQUEST = "GET_EFCI_BASED_ON_BUILDING_REQUEST";
export const GET_EFCI_BASED_ON_BUILDING_SUCCESS = "GET_EFCI_BASED_ON_BUILDING_SUCCESS";
export const GET_EFCI_BASED_ON_BUILDING_FAILURE = "GET_EFCI_BASED_ON_BUILDING_FAILURE";

// Update Capital Spending Percent
export const UPDATE_CAPITAL_SPENDING_PERCENT_REQUEST = "UPDATE_CAPITAL_SPENDING_PERCENT_REQUEST";
export const UPDATE_CAPITAL_SPENDING_PERCENT_SUCCESS = "UPDATE_CAPITAL_SPENDING_PERCENT_SUCCESS";
export const UPDATE_CAPITAL_SPENDING_PERCENT_FAILURE = "UPDATE_CAPITAL_SPENDING_PERCENT_FAILURE";

export const UPDATE_ANNUAL_FUNDING_OPTION_REQUEST = "UPDATE_ANNUAL_FUNDING_OPTION_REQUEST";
export const UPDATE_ANNUAL_FUNDING_OPTION_SUCCESS = "UPDATE_ANNUAL_FUNDING_OPTION_SUCCESS";
export const UPDATE_ANNUAL_FUNDING_OPTION_FAILURE = "UPDATE_ANNUAL_FUNDING_OPTION_FAILURE";

export const UPDATE_FUNDING_COST_REQUEST = "UPDATE_FUNDING_COST_REQUEST";
export const UPDATE_FUNDING_COST_SUCCESS = "UPDATE_FUNDING_COST_SUCCESS";
export const UPDATE_FUNDING_COST_FAILURE = "UPDATE_FUNDING_COST_FAILURE";

export const UPDATE_FCI_AMOUNT_REQUEST = "UPDATE_FCI_AMOUNT_REQUEST";
export const UPDATE_FCI_AMOUNT_SUCCESS = "UPDATE_FCI_AMOUNT_SUCCESS";
export const UPDATE_FCI_AMOUNT_FAILURE = "UPDATE_FCI_AMOUNT_FAILURE";

export const UPDATE_FUNDING_EFCI_REQUEST = "UPDATE_FUNDING_EFCI_REQUEST";
export const UPDATE_FUNDING_EFCI_SUCCESS = "UPDATE_FUNDING_EFCI_SUCCESS";
export const UPDATE_FUNDING_EFCI_FAILURE = "UPDATE_FUNDING_EFCI_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const HIDE_FUNDING_OPTION_REQUEST = "HIDE_FUNDING_OPTION_REQUEST";
export const HIDE_FUNDING_OPTION_SUCCESS = "HIDE_FUNDING_OPTION_SUCCESS";
export const HIDE_FUNDING_OPTION_FAILURE = "HIDE_FUNDING_OPTION_FAILURE";

export const GET_BUILDING_TYPES_BASED_ON_CLIENT_REQUEST = "GET_BUILDING_TYPES_BASED_ON_CLIENT_REQUEST";
export const GET_BUILDING_TYPES_BASED_ON_CLIENT_SUCCESS = "GET_BUILDING_TYPES_BASED_ON_CLIENT_SUCCESS";
export const GET_BUILDING_TYPES_BASED_ON_CLIENT_FAILURE = "GET_BUILDING_TYPES_BASED_ON_CLIENT_FAILURE";

export const UPDATE_BUILDING_LOCK_EFCI_REQUEST = "UPDATE_BUILDING_LOCK_EFCI_REQUEST";
export const UPDATE_BUILDING_LOCK_EFCI_SUCCESS = "UPDATE_BUILDING_LOCK_EFCI_SUCCESS";
export const UPDATE_BUILDING_LOCK_EFCI_FAILURE = "UPDATE_BUILDING_LOCK_EFCI_FAILURE";

export const HIDE_FUNDING_OPTION_BUILDING_SITE_REQUEST = "HIDE_FUNDING_OPTION_BUILDING_SITE_REQUEST";
export const HIDE_FUNDING_OPTION_BUILDING_SITE_SUCCESS = "HIDE_FUNDING_OPTION_BUILDING_SITE_SUCCESS";
export const HIDE_FUNDING_OPTION_BUILDING_SITE_FAILURE = "HIDE_FUNDING_OPTION_BUILDING_SITE_FAILURE";

export const GET_CHART_BUILDING_REQUEST = "GET_CHART_BUILDING_REQUEST";
export const GET_CHART_BUILDING_SUCCESS = "GET_CHART_BUILDING_SUCCESS";
export const GET_CHART_BUILDING_FAILURE = "GET_CHART_BUILDING_FAILURE";

export const SAVE_EFCI_BUILDING_REQUEST = "SAVE_EFCI_BUILDING_REQUEST";
export const SAVE_EFCI_BUILDING_SUCCESS = "SAVE_EFCI_BUILDING_SUCCESS";
export const SAVE_EFCI_BUILDING_FAILURE = "SAVE_EFCI_BUILDING_FAILURE";

export const LOAD_EFCI_BUILDING_REQUEST = "LOAD_EFCI_BUILDING_REQUEST";
export const LOAD_EFCI_BUILDING_SUCCESS = "LOAD_EFCI_BUILDING_SUCCESS";
export const LOAD_EFCI_BUILDING_FAILURE = "LOAD_EFCI_BUILDING_FAILURE";

export const LOCK_EFCI_BUILDING_REQUEST = "LOCK_EFCI_BUILDING_REQUEST";
export const LOCK_EFCI_BUILDING_SUCCESS = "LOCK_EFCI_BUILDING_SUCCESS";
export const LOCK_EFCI_BUILDING_FAILURE = "LOCK_EFCI_BUILDING_FAILURE";

// get chart efci information
export const GET_CHART_BUILDING_EFCI_REQUEST = "GET_CHART_BUILDING_EFCI_REQUEST";
export const GET_CHART_BUILDING_EFCI_SUCCESS = "GET_CHART_BUILDING_EFCI_SUCCESS";
export const GET_CHART_BUILDING_EFCI_FAILURE = "GET_CHART_BUILDING_EFCI_FAILURE";

export const GET_ALL_BUILDING_LOG_REQUEST = "GET_ALL_BUILDING_LOG_REQUEST";
export const GET_ALL_BUILDING_LOG_SUCCESS = "GET_ALL_BUILDING_LOG_SUCCESS";
export const GET_ALL_BUILDING_LOG_FAILURE = "GET_ALL_BUILDING_LOG_FAILURE";

export const RESTORE_BUILDING_LOG_REQUEST = "RESTORE_BUILDING_LOG_REQUEST";
export const RESTORE_BUILDING_LOG_SUCCESS = "RESTORE_BUILDING_LOG_SUCCESS";
export const RESTORE_BUILDING_LOG_FAILURE = "RESTORE_BUILDING_LOG_FAILURE";

export const DELETE_BUILDING_LOG_REQUEST = "DELETE_BUILDING_LOG_REQUEST";
export const DELETE_BUILDING_LOG_SUCCESS = "DELETE_BUILDING_LOG_SUCCESS";
export const DELETE_BUILDING_LOG_FAILURE = "DELETE_BUILDING_LOG_FAILURE";

export const GET_CSP_LOG_REQUEST = "GET_CSP_LOG_REQUEST";
export const GET_CSP_LOG_SUCCESS = "GET_CSP_LOG_SUCCESS";
export const GET_CSP_LOG_FAILURE = "GET_CSP_LOG_FAILURE";

export const RESTORE_CSP_LOG_REQUEST = "RESTORE_CSP_LOG_REQUEST";
export const RESTORE_CSP_LOG_SUCCESS = "RESTORE_CSP_LOG_SUCCESS";
export const RESTORE_CSP_LOG_FAILURE = "RESTORE_CSP_LOG_FAILURE";

export const GET_FUNDING_COST_LOG_REQUEST = "GET_FUNDING_COST_LOG_REQUEST";
export const GET_FUNDING_COST_LOG_SUCCESS = "GET_FUNDING_COST_LOG_SUCCESS";
export const GET_FUNDING_COST_LOG_FAILURE = "GET_FUNDING_COST_LOG_FAILURE";

export const RESTORE_FUNDING_COST_LOG_REQUEST = "RESTORE_FUNDING_COST_LOG_REQUEST";
export const RESTORE_FUNDING_COST_LOG_SUCCESS = "RESTORE_FUNDING_COST_LOG_SUCCESS";
export const RESTORE_FUNDING_COST_LOG_FAILURE = "RESTORE_FUNDING_COST_LOG_FAILURE";

export const GET_FUNDING_COST_EFCI_LOG_REQUEST = "GET_FUNDING_COST_EFCI_LOG_REQUEST";
export const GET_FUNDING_COST_EFCI_LOG_SUCCESS = "GET_FUNDING_COST_EFCI_LOG_SUCCESS";
export const GET_FUNDING_COST_EFCI_LOG_FAILURE = "GET_FUNDING_COST_EFCI_LOG_FAILURE";

export const RESTORE_FUNDING_COST_EFCI_LOG_REQUEST = "RESTORE_FUNDING_COST_EFCI_LOG_REQUEST";
export const RESTORE_FUNDING_COST_EFCI_LOG_SUCCESS = "RESTORE_FUNDING_COST_EFCI_LOG_SUCCESS";
export const RESTORE_FUNDING_COST_EFCI_LOG_FAILURE = "RESTORE_FUNDING_COST_EFCI_LOG_FAILURE";

export const GET_TOTAL_FUNDING_COST_EFCI_LOG_REQUEST = "GET_TOTAL_FUNDING_COST_EFCI_LOG_REQUEST";
export const GET_TOTAL__FUNDING_COST_EFCI_LOG_SUCCESS = "GET_TOTAL__FUNDING_COST_EFCI_LOG_SUCCESS";
export const GET_TOTAL_FUNDING_COST_EFCI_LOG_FAILURE = "GET_TOTAL_FUNDING_COST_EFCI_LOG_FAILURE";

export const RESTORE_TOTAL_FUNDING_COST_EFCI_LOG_REQUEST = "RESTORE_TOTAL_FUNDING_COST_EFCI_LOG_REQUEST";
export const RESTORE_TOTAL_FUNDING_COST_EFCI_LOG_SUCCESS = "RESTORE_TOTAL_FUNDING_COST_EFCI_LOG_SUCCESS";
export const RESTORE_TOTAL_FUNDING_COST_EFCI_LOG_FAILURE = "RESTORE_TOTAL_FUNDING_COST_EFCI_LOG_FAILURE";

export const GET_ANNUAL_FUNDING_COST_EFCI_LOG_REQUEST = "GET_ANNUAL_FUNDING_COST_EFCI_LOG_REQUEST";
export const GET_ANNUAL_FUNDING_COST_EFCI_LOG_SUCCESS = "GET_ANNUAL_FUNDING_COST_EFCI_LOG_SUCCESS";
export const GET_ANNUAL_FUNDING_COST_EFCI_LOG_FAILURE = "GET_ANNUAL_FUNDING_COST_EFCI_LOG_FAILURE";

export const RESTORE_ANNUAL_FUNDING_COST_EFCI_LOG_REQUEST = "RESTORE_ANNUAL_FUNDING_COST_EFCI_LOG_REQUEST";
export const RESTORE_ANNUAL_FUNDING_COST_EFCI_LOG_SUCCESS = "RESTORE_ANNUAL_FUNDING_COST_EFCI_LOG_SUCCESS";
export const RESTORE_ANNUAL_FUNDING_COST_EFCI_LOG_FAILURE = "RESTORE_ANNUAL_FUNDING_COST_EFCI_LOG_FAILURE";

export const GET_ANNUAL_EFCI_LOG_REQUEST = "GET_ANNUAL_EFCI_LOG_REQUEST";
export const GET_ANNUAL_EFCI_LOG_SUCCESS = "GET_ANNUAL_EFCI_LOG_SUCCESS";
export const GET_ANNUAL_EFCI_LOG_FAILURE = "GET_ANNUAL_EFCI_LOG_FAILURE";

export const RESTORE_ANNUAL_EFCI_LOG_REQUEST = "RESTORE_ANNUAL_EFCI_LOG_REQUEST";
export const RESTORET_ANNUAL_EFCI_LOG_SUCCESS = "RESTORET_ANNUAL_EFCI_LOG_SUCCESS";
export const RESTORE_ANNUAL_EFCI_LOG_FAILURE = "RESTORE_ANNUAL_EFCI_LOG_FAILURE";

export const GET_BUILDING_EXPORT_REQUEST = "GET_BUILDING_EXPORT_REQUEST";
export const GET_BUILDING_EXPORT_SUCCESS = "GET_BUILDING_EXPORT_SUCCESS";
export const GET_BUILDING_EXPORT_FAILURE = "GET_BUILDING_EXPORT_FAILURE";

export const GET_ALL_CLIENT_USERS_REQUEST = "GET_ALL_CLIENT_USERS_REQUEST";
export const GET_ALL_CLIENT_USERS_SUCCESS = "GET_ALL_CLIENT_USERS_SUCCESS";
export const GET_ALL_CLIENT_USERS_FAILURE = "GET_ALL_CLIENT_USERS_FAILURE";

export const GET_ALL_CONSULTANCIES_DROPDOWN_REQUEST = "GET_ALL_CONSULTANCIES_DROPDOWN_REQUEST";
export const GET_ALL_CONSULTANCIES_DROPDOWN_SUCCESS = "GET_ALL_CONSULTANCIES_DROPDOWN_SUCCESS";
export const GET_ALL_CONSULTANCIES_DROPDOWN_FAILURE = "GET_ALL_CONSULTANCIES_DROPDOWN_FAILURE";

// export const GET_CHART_BUILDING_EXPORT_REQUEST = "GET_BUILDING_CHART_EXPORT_REQUEST";
// export const GET_CHART_BUILDING_EXPORT_SUCCESS = "GET_CHART_BUILDING_EXPORT_SUCCESS";
// export const GET_CHAR_BUILDINGT_EXPORT_FAILURE = "GET_CHART_BUILDING_EXPORT_FAILURE";

export const GET_BBI_PREVIEW_REQUEST = "GET_BBI_PREVIEW_REQUEST";
export const GET_BBI_PREVIEW_SUCCESS = "GET_BBI_PREVIEW_SUCCESS";
export const GET_BBI_PREVIEW_FAILURE = "GET_BBI_PREVIEW_FAILURE";

export const EXPORT_DOC_BBI_REQUEST = "EXPORT_DOC_BBI_REQUEST";
export const EXPORT_DOC_BBI_SUCCESS = "EXPORT_DOC_BBI_SUCCESS";
export const EXPORT_DOC_BBI_FAILURE = "EXPORT_DOC_BBI_FAILURE";

// For Export Settings
export const GET_EXPORT_PROPERTY_DROPDOWN_FOR_BUILDING_REQUEST = "GET_EXPORT_PROPERTY_DROPDOWN_FOR_BUILDING_REQUEST";
export const GET_EXPORT_PROPERTY_DROPDOWN_FOR_BUILDING_SUCCESS = "GET_EXPORT_PROPERTY_DROPDOWN_FOR_BUILDING_SUCCESS";
export const GET_EXPORT_PROPERTY_DROPDOWN_FOR_BUILDING_FAILURE = "GET_EXPORT_PROPERTY_DROPDOWN_FOR_BUILDING_FAILURE";

export const GET_BUILDING_DYNAMIC_FIELDS_REQUEST = "GET_BUILDING_DYNAMIC_FIELDS_REQUEST";
export const GET_BUILDING_DYNAMIC_FIELDS_SUCCESS = "GET_BUILDING_DYNAMIC_FIELDS_SUCCESS";
export const GET_BUILDING_DYNAMIC_FIELDS_FAILURE = "GET_BUILDING_DYNAMIC_FIELDS_FAILURE";

// get all building ids
export const GET_ALL_BUILDINGS_IDS_REQUEST = "GET_ALL_BUILDINGS_IDS_REQUEST";
export const GET_ALL_BUILDINGS_IDS_SUCCESS = "GET_ALL_BUILDINGS_IDS_SUCCESS";
export const GET_ALL_BUILDINGS_IDS_FAILURE = "GET_ALL_BUILDINGS_IDS_FAILURE";

export const GET_GAUGE_CHART_DATA_REQUEST = "GET_GAUGE_CHART_DATA_REQUEST";
export const GET_GAUGE_CHART_DATA_SUCCESS = "GET_GAUGE_CHART_DATA_SUCCESS";
export const GET_GAUGE_CHART_DATA_FAILURE = "GET_GAUGE_CHART_DATA_FAILURE";

export const GET_BUILDING_EXECUTIVE_SUMMARY_REQUEST = "GET_BUILDING_EXECUTIVE_SUMMARY_REQUEST";
export const GET_BUILDING_EXECUTIVE_SUMMARY_SUCCESS = "GET_BUILDING_EXECUTIVE_SUMMARY_SUCCESS";
export const GET_BUILDING_EXECUTIVE_SUMMARY_FAILURE = "GET_BUILDING_EXECUTIVE_SUMMARY_FAILURE";

export const SAVE_BUILDING_EXECUTIVE_SUMMARY_REQUEST = "SAVE_BUILDING_EXECUTIVE_SUMMARY_REQUEST";
export const SAVE_BUILDING_EXECUTIVE_SUMMARY_SUCCESS = "SAVE_BUILDING_EXECUTIVE_SUMMARY_SUCCESS";
export const SAVE_BUILDING_EXECUTIVE_SUMMARY_FAILURE = "SAVE_BUILDING_EXECUTIVE_SUMMARY_FAILURE";

export const APPLY_EXECUTIVE_SUMMARY_TEMPLATE_TO_BUILDINGS_REQUEST = "APPLY_EXECUTIVE_SUMMARY_TEMPLATE_TO_BUILDINGS_REQUEST";
export const APPLY_EXECUTIVE_SUMMARY_TEMPLATE_TO_BUILDINGS_SUCCESS = "APPLY_EXECUTIVE_SUMMARY_TEMPLATE_TO_BUILDINGS_SUCCESS";
export const APPLY_EXECUTIVE_SUMMARY_TEMPLATE_TO_BUILDINGS_FAILURE = "APPLY_EXECUTIVE_SUMMARY_TEMPLATE_TO_BUILDINGS_FAILURE";
